import {
    Component,
    Input,
    OnChanges,
    OnInit,
    OnDestroy,
    SimpleChanges,
} from '@angular/core';
import { LocalBusinesses, PrincipalData } from '@app/models';
import { StoreProvider } from '@app/providers';
import { Subscription } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-counting-main',
    templateUrl: './counting-main.component.html',
    styleUrls: ['./counting-main.component.scss'],
})
export class CountingMainComponent implements OnChanges, OnInit, OnDestroy {
    @Input() selectedLocalBusiness!: LocalBusinesses;
    @Input() principalData!: PrincipalData;

    public entriesKeys: string[] = [];
    public entriesExpanded = false;
    public displayRegisterDataInfo = true;
    public settings: any = null;

    private settingsSub$!: Subscription;

    constructor(private store: StoreProvider) {}

    ngOnInit(): void {
        this.settingsSub$ = this.store.settings$.subscribe((settings) => {
            this.settings = settings;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['principalData'] && this.principalData?.current?.entries) {
            this.entriesKeys = Object.keys(this.principalData.current.entries);
        }
    }

    public toggleEntries(): void {
        this.entriesExpanded = !this.entriesExpanded;
    }

    public deleteInfo(): void {
        this.displayRegisterDataInfo = false;
    }

    // Nombre total d'encadrés de données affichés (hors bannières d'info)
    public get visibleCardsCount(): number {
        let count = 0;

        if (this.selectedLocalBusiness?.groupsCountingEnabled) {
            count += 1;
        }

        if (this.entriesKeys.length > 1) {
            count += 1;
        }

        if (this.settings?.attractivity) {
            count += 2; // passages + attractivité
        }

        if (this.selectedLocalBusiness?.localBusinessFiancial) {
            count += 2; // turnover + taux de transformation
        }

        return count;
    }

    // Seuil en dessous duquel on centre verticalement le contenu
    public get shouldCenterContent(): boolean {
        return this.visibleCardsCount <= 2;
    }

    ngOnDestroy(): void {
        this.settingsSub$?.unsubscribe();
    }
}
